import { getItemFromCollection } from "directus/src/operations";

export async function fetchCategoryData({ categoryId }) {
  try {
    const response = await getItemFromCollection("survey_categories", categoryId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
